var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnabled)?_c('div',[_c('audio',{ref:"remoteAudio",attrs:{"id":"remoteAudio","autoplay":""}}),_vm._v(" "),_c('call-modal'),_vm._v(" "),_c('call-mini-bar')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }